export function toScrollAnchorId(componentId: string) {
  return `sc-id-${componentId}`;
}
